import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AlertService} from '../../shared/services/alert.service';
import {Messages} from '../../shared/constants/messages';
import {OrganizationService} from '../../shared/services/organization.service';
import {PermissionService} from '../services/permission.service';
import {SystemPower} from '../../shared/model/permissions';
import {map} from 'rxjs';

export const organizationManagerGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const alertService: AlertService = inject(AlertService);
  const organizationService: OrganizationService = inject(OrganizationService);
  const permissionService: PermissionService = inject(PermissionService);

  if (!permissionService.isLogged()) {
    alertService.showError(Messages.LOGIN_REQUIRED);
    return router.navigate(['/login']);
  }

  // L'amministratore di sistema gestisce tutte le organizzazioni (power >= 70 / capability)
  if (permissionService.hasSystemPower(SystemPower.MODERATOR)) {
    return true;
  }

  const currentUser = permissionService.getCurrentUser();

  // Se il backend ha già esposto le organizzazioni nello user (campo organizations),
  // verifichiamo in modo sincrono senza chiamate extra
  if (currentUser && Array.isArray(currentUser.organizations)) {
    const managesOrganization = currentUser.organizations.some((org) =>
      permissionService.canManageOrgMembers(org) || permissionService.canEditOrg(org)
    );
    if (managesOrganization) {
      return true;
    }
    alertService.showError(Messages.ORGANIZATION_MANAGER_ONLY);
    return router.parseUrl('/home');
  }

  // Fallback: verifica async sulle organizzazioni gestite dall'utente
  return organizationService.getMyOrganizations().pipe(
    map((response) => {
      const managesOrganization =
        response.success && response.data
          ? response.data.length > 0
          : false;

      if (managesOrganization) {
        return true;
      }

      alertService.showError(Messages.ORGANIZATION_MANAGER_ONLY);
      return router.parseUrl('/home');
    })
  );
};